






















import Vue from "vue";
// import SidePanel from "./SidePanel.vue"
import BsvSidepanel from "@/components/BsvSidepanel.vue"
import MobileMenu from "@/components/MobileMenu.vue"
import SiteHeader from "./SiteHeader.vue";
import store from "./store";

export default Vue.extend({
	components: {
		//SidePanel,
		SiteHeader,
		BsvSidepanel,
		MobileMenu
	},

	data() {
		return {
			isOpen: false,
		};
	},

	mounted() {
		store.commit("setMobile", this.windowWidth)
		store.commit("setMobileMenu", false)
		this.windowWidth < 576 ? this.isOpen = false : this.isOpen = true;
	},

	methods: {
		resizePanel() {
			this.isOpen = !this.isOpen;
		},
		closePanel() {
			this.isOpen = false;
		},
		togglePanel() {
			this.isOpen = !this.isOpen
		},
		toggleMobileMenu() {
			store.commit("setMobileMenu", !this.showMobileMenu)
		}
	},
	computed: {
		isLoggedIn() {
			if (this.$store.state.strongAuth) {
				return true;
			} else {
				return false;
			}
		},
		windowWidth() {
			let width = window.document.body.clientWidth;
			return width;
		},
		showMobileMenu() {
			return store.state.showMobileMenu;
		},
		isMobile() {
			return store.getters.isMobile;
		},
		org() {
			return this.$router.currentRoute.params.org;
		}
	},
});
